import laundriesService from "api/laundriesService";
import { useMutation } from "react-query";

import { IAddAdminLaundryHolidayBody } from "types/laundry";

const useAddAdminLaundryHolidayMutation = () => {
  return useMutation(async (data: IAddAdminLaundryHolidayBody) => {
    try {

      const res = await laundriesService.addAdminLaundryHolidays(data)
      return res.data
    } catch (err: any) {
      return {
        err: err.message,
        errStatus: err.response.status,
      }
    }
  }) 
}

export default useAddAdminLaundryHolidayMutation